"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5397],{

/***/ 42980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Actions = function Actions(_ref) {
  var active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary,
      inline = _ref.inline;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .SimpleGrid */ .MI, {
    columns: {
      base: inline && hasSecondaryAction ? 2 : 1,
      md: inline ? 2 : 1
    },
    spacing: {
      base: '1rem',
      md: inline ? '1.5rem' : '.5rem'
    },
    children: [hasSecondaryAction && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .SecondaryButton */ .kq, {
      title: secondary.title,
      action: secondary.action,
      onClick: secondary.onClick
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .PrimaryButton */ .KM, {
      title: primary.title,
      action: primary.action,
      onClick: primary.onClick,
      disabled: !active
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Actions);

/***/ }),

/***/ 55397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OfferDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var dist_index_esm = __webpack_require__(68185);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(57543);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Title.tsx






var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      brandImage = _ref.brandImage,
      brandImageAlt = _ref.brandImageAlt;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
    templateColumns: {
      base: '1fr',
      md: '0.25fr 1fr'
    },
    alignItems: "center",
    children: [brandImage && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      p: 0,
      m: 0,
      h: "60px",
      display: {
        base: 'none',
        md: 'block'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        objectFit: "contain",
        src: brandImage,
        width: "60",
        height: "60",
        alt: brandImageAlt
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        as: "h1",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.75rem",
        letterSpacing: "0.86px",
        mt: "-7px",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        marginTop: "xs",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        textTransform: "capitalize",
        lineHeight: "23.4px",
        letterSpacing: "0.3px",
        children: subtitle
      })]
    })]
  });
};

/* harmony default export */ var OfferDetails_Title = (Title);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Description.tsx


var _excluded = ["icon", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var BadgeWithIconCustom = function BadgeWithIconCustom(_ref) {
  var icon = _ref.icon,
      name = _ref.name,
      value = _ref.value,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* BadgeWithIcon */.eF, _objectSpread({
    icon: icon,
    name: name,
    value: value,
    fontFamily: "Montserrat-Regular, san-serif",
    fontSize: ".875rem",
    color: "#262626",
    marginBottom: "6px"
  }, others));
};

var Description = function Description(_ref2) {
  var fuelTitle = _ref2.fuelTitle,
      fuelValue = _ref2.fuelValue,
      transmissionTitle = _ref2.transmissionTitle,
      transmissionValue = _ref2.transmissionValue,
      powerTitle = _ref2.powerTitle,
      powerValue = _ref2.powerValue,
      priceValue = _ref2.priceValue,
      priceDescription = _ref2.priceDescription;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    textAlign: "left",
    position: "relative",
    marginTop: "1.3rem!important",
    marginBottom: "0",
    marginLeft: "-3px",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenFuelIcon */.af, {}),
      name: fuelTitle,
      value: fuelValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenTransmissionIcon */.Fe, {}),
      name: transmissionTitle,
      value: transmissionValue,
      marginLeft: "-2px"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenPowerIcon */.b3, {}),
      name: powerTitle,
      value: powerValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* PriceBox */.bz, {
      value: priceValue,
      description: priceDescription,
      textAlign: "right",
      position: "absolute",
      top: "-3px",
      right: "0"
    })]
  });
};

/* harmony default export */ var OfferDetails_Description = (Description);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Offer.tsx







var OfferDetails = function OfferDetails(_ref) {
  var sectionTitle = _ref.sectionTitle,
      durationTitle = _ref.durationTitle,
      durationValue = _ref.durationValue,
      distanceTitle = _ref.distanceTitle,
      distanceValue = _ref.distanceValue,
      depositTitle = _ref.depositTitle,
      depositValue = _ref.depositValue,
      depositDescription = _ref.depositDescription,
      onHoverMessage = _ref.onHoverMessage,
      expirationValue = _ref.expirationValue,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        display: "inline",
        fontSize: "1rem",
        lineHeight: "30.8x",
        letterSpacing: "0.2px",
        children: sectionTitle
      }), expirationValue && expirationValue.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* LimitedOfferBadge */.Ld, {
        display: "inline",
        float: "right",
        children: expirationValue
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
      columns: 3,
      spacing: ".688rem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCalendarIcon */.cd, {}),
        title: durationTitle,
        description: durationValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCarIconSecondary */.Mr, {}),
        title: distanceTitle,
        description: distanceValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenPocketIcon */.ec, {}),
        title: depositTitle,
        description: "".concat(depositValue, " ").concat(depositDescription),
        onHoverMessage: onHoverMessage,
        onClick: onClick
      })]
    })]
  });
};

/* harmony default export */ var Offer = (OfferDetails);
// EXTERNAL MODULE: ./src/components/OfferDetails/Actions.tsx
var Actions = __webpack_require__(42980);
;// CONCATENATED MODULE: ./src/components/OfferDetails/index.tsx











var OfferDetails_OfferDetails = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      brandImage = _ref.brandImage,
      brandImageAlt = _ref.brandImageAlt,
      sectionTitle = _ref.sectionTitle,
      durationTitle = _ref.durationTitle,
      durationValue = _ref.durationValue,
      distanceValue = _ref.distanceValue,
      distanceTitle = _ref.distanceTitle,
      depositValue = _ref.depositValue,
      depositDescription = _ref.depositDescription,
      depositTitle = _ref.depositTitle,
      expirationValue = _ref.expirationValue,
      onHoverMessage = _ref.onHoverMessage,
      onClick = _ref.onClick,
      fuelTitle = _ref.fuelTitle,
      fuelValue = _ref.fuelValue,
      transmissionTitle = _ref.transmissionTitle,
      transmissionValue = _ref.transmissionValue,
      powerTitle = _ref.powerTitle,
      powerValue = _ref.powerValue,
      priceValue = _ref.priceValue,
      priceDescription = _ref.priceDescription,
      insurances = _ref.insurances,
      active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary;
  var dispatch = (0,es/* useDispatch */.I0)();
  var priceVatIncluded = (0,es/* useSelector */.v9)(function (state) {
    return state.nlt.priceVatIncluded;
  });

  var _useState = (0,react.useState)(false),
      priceVatIncludedChecked = _useState[0],
      setPriceVatIncludedChecked = _useState[1];

  (0,react.useEffect)(function () {
    return setPriceVatIncludedChecked(!priceVatIncluded);
  }, [priceVatIncluded]);

  var togglePriceVatIncluded = function togglePriceVatIncluded() {
    setPriceVatIncludedChecked(!priceVatIncludedChecked);
    dispatch((0,actions/* showPriceVatIncluded */.GR)(priceVatIncludedChecked));
  }; // @ts-ignore


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
    maxW: "6xl",
    px: 0,
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Title, {
      title: title,
      subtitle: subtitle,
      brandImage: brandImage,
      brandImageAlt: brandImageAlt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Offer, {
      sectionTitle: sectionTitle,
      durationTitle: durationTitle,
      durationValue: durationValue,
      distanceValue: distanceValue,
      distanceTitle: distanceTitle,
      depositValue: depositValue,
      depositDescription: depositDescription,
      depositTitle: depositTitle,
      expirationValue: expirationValue,
      onClick: hasSecondaryAction ? onClick : null,
      onHoverMessage: onHoverMessage
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Description, {
      fuelTitle: fuelTitle,
      fuelValue: fuelValue,
      transmissionTitle: transmissionTitle,
      transmissionValue: transmissionValue,
      powerTitle: powerTitle,
      powerValue: powerValue,
      priceValue: priceValue,
      priceDescription: priceDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      mt: "-30px",
      textAlign: "right",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        as: "span",
        children: priceVatIncluded ? "IVA inclusa" : "IVA esclusa"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Switch */.r, {
        ml: "6px",
        colorScheme: "green",
        isChecked: priceVatIncluded,
        float: "right",
        value: "1",
        onChange: togglePriceVatIncluded
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Actions/* default */.Z, {
      active: active,
      primary: primary,
      hasSecondaryAction: hasSecondaryAction,
      secondary: secondary,
      inline: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SimpleList */.LZ, {
      insurances: insurances
    })]
  });
});
OfferDetails_OfferDetails.displayName = 'OfferDetails';
/* harmony default export */ var components_OfferDetails = (OfferDetails_OfferDetails);

/***/ })

}]);